import type { ViewFetchState } from '@bliks-io/ui';
import { isNotFoundError } from '@/api/errors';

interface DialogQuery {
  data: unknown;
  error: unknown;
  isFetching: boolean;
  refetch: () => unknown;
}

/**
 * Why a dialog fed by one or more queries has nothing to show. Pending while
 * any query fetches — not only on the first load — so a Retry over a cached,
 * incomplete result shows the skeleton instead of a stale not-found.
 */
export function readDialogLoadState(queries: DialogQuery[], targetMissing = false): ViewFetchState {
  if (queries.some((query) => query.isFetching)) return { status: 'pending' };

  const failed = queries.find((query) => query.data === undefined && query.error);
  if (failed) {
    return isNotFoundError(failed.error)
      ? { status: 'unavailable' }
      : { status: 'failed', retry: () => void failed.refetch() };
  }

  return targetMissing ? { status: 'unavailable' } : { status: 'pending' };
}
